<template>
  <span class="member-roles">
    <template v-if="sortedRoles.length > maxBadges">
      <span 
        v-for="role in sortedRoles.slice(0, Math.max(1, maxBadges - 1))" 
        :key="role" 
        class="member-role" 
        :class="role.toLowerCase().replace(/\s+/g, '-')"
      >
        {{ role }}
      </span>
      <span 
        v-if="maxBadges > 1"
        class="member-role more"
        :title="extraRoles.join(', ')"
      >
        +{{ sortedRoles.length - (maxBadges - 1) }} more
      </span>
    </template>
    <template v-else>
      <span 
        v-for="role in sortedRoles" 
        :key="role" 
        class="member-role" 
        :class="role.toLowerCase().replace(/\s+/g, '-')"
      >
        {{ role }}
      </span>
    </template>
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { sortRoles } from '@/scripts/permissions';

const props = defineProps({
  roles: {
    type: Array,
    required: true,
    default: () => []
  },
  maxBadges: {
    type: Number,
    default: 2
  }
});

const sortedRoles = computed(() => {
  return sortRoles(props.roles);
});

const extraRoles = computed(() => {
  if (sortedRoles.value.length <= props.maxBadges) return [];
  return sortedRoles.value.slice(props.maxBadges - 1);
});
</script>

<style scoped>
@import '@/styles/organization-members.css';
</style>
